export class TaskItem {
  companyid: number;
  projectid: number;
  taskid: number;
  taskCode: string;
  taskDescription: string;
  taskName: string;
  inputId: number;

  public get id(): string {
    return this.companyid + '/' + this.projectid + '/' + this.taskid;
  }

  getFormattedNumber(value: number): string{
    if (!value)
    {
      value = 0.0;
    }
    return value.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
